<template>
  <div class="project-structure-tree-container">

    <div class="project-structure-tree-container-header" v-if="header || header_only" :style="header_only?'padding: 0px; height: 100%;':''">
      <slot name="header">
      </slot>
    </div>

    <!-- <div class="project-structure-tree-container-title">
      {{ title }}
    </div> -->

    <div class="project-structure-tree-container-content" v-if="!header_only">
      <div class="project-structure-tree-container-body">
        <slot name="body">
        </slot>
      </div>

      <div v-if="body_center">
        <slot name="body_center">
        </slot>
      </div>

      <div class="project-structure-tree-container-body" v-if="body2">
        <slot name="body2">
        </slot>
      </div>
    </div>

    <div class="project-structure-tree-container-bottom">
      <slot name="bottom">
        </slot>
    </div>

    

  </div>
</template>
<script>
export default {
  props: ['title', 'body2', 'body_center', 'header', 'header_only'],
  data: () => ({
  }),
}
</script>



<style>
.project-structure-tree-container {
  /* background-color: gray; */
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: rgba(39,39,39,0.7);
  border-radius: 4px;
  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); */
  width: 100%;
  height: 100%;
  padding: 5px 5px 5px 5px;
  pointer-events: all;
}

.project-structure-tree-container-header {
  width: 100%;

  display: flex;
  position: relative;
  /* align-items: stretch; //hp später schauen wegen search bar */
  height: auto;
  gap: 10px;
  padding: 5px 0;

}

.project-structure-tree-container-content {
  display: flex;
  flex-direction: row;
  height: 100%;
  column-gap: 5px;
  
  position: relative;
  overflow: auto;

}

.project-structure-tree-container-body {
  display: flex;
  /* align-items: stretch; //hp später schauen wegen search bar */
  /* align-self: flex-start; */
  position: relative;
  overflow: auto;
  /* overflow-y: scroll; */
  /* overflow-x: unset; */
  height: 100%;
  width: 100%;
  /* min-width: 200px; */

  background-color: rgba(39, 39, 39, 0.7);
  /* background: rgba(30, 28, 45, 0.7); */
  /* backdrop-filter: blur(24px) brightness(95%);
    -webkit-backdrop-filter: blur(24px) brightness(95%); */
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); */

}
</style>
  